import _ from 'lodash';
import React, { useState } from 'react';
import { track } from '../../analytics/utils';
import {
  Border,
  Box,
  Button,
  DropDown,
  Flex,
  Margin,
  Padding,
  Queue,
  Spinner,
  Stack,
  Text,
} from '../../components';
import { GreenHouseAPI } from './api';
import { Navigation } from './shared';

const PositionDetails = (props) => {
  let { openJob, loading } = props;
  let { departments, location, title, absolute_url } = openJob || {
    absolute_url: '',
    departments: '',
    location: '',
    title: '',
  };
  const handleOnClick = () => {
    track('Apply Link Clicked', {
      job_title: title,
      department_name: departments[0]?.name,
      greenhouse_job_id: parseInt(absolute_url.split('=')[1]),
    });
    window.open(`${absolute_url}`, '_blank');
  };
  if (loading) {
    return (
      <>
        <Padding size={[0, 0, 0, 5]}>
          <Queue size={4}>
            <Flex>
              <Spinner />
            </Flex>
            <Flex flex={2}>
              <Text align="left">loading...</Text>
              <Text textType="primary5" align="left">
                Loading...
              </Text>
            </Flex>
          </Queue>
        </Padding>
        <Border borderSize={[1, 0, 0, 0]} borderRole="grey3" />
      </>
    );
  }
  return (
    <>
      <Padding size={[0, 0, 0, 5]}>
        <Queue>
          <Flex flex={2}>
            <Text align="left">{departments[0]?.name}</Text>

            <Margin size={[0, 2, 0, 0]}>
              <Text textType="primary1" align="left">
                {title}
              </Text>
            </Margin>
          </Flex>
          <Flex flex={1}>
            <Text align="left">Location</Text>
            <Text textType="primary1" align="left" vertical="top">
              {location?.name}
            </Text>
          </Flex>
          <Flex flex={1}>
            {title ? (
              <Padding size={[0, 6]} height="100%">
                <Button
                  borderSize={[1]}
                  radius="small"
                  borderRole="grey"
                  backgroundRole="white"
                  width="100%"
                  onClick={handleOnClick}
                >
                  Learn More
                </Button>
              </Padding>
            ) : (
              <Spinner />
            )}
          </Flex>
        </Queue>
      </Padding>
      <Border borderSize={[1, 0, 0, 0]} borderRole="grey3" />
    </>
  );
};

export const OpenRolesDesktop = () => {
  let { fetchedData, loading } = GreenHouseAPI();
  let { jobs: openJobs } = fetchedData || {
    jobs: [null, null, null, null],
  };
  let locations = _.flow(
    (openJobs) => _.map(openJobs, 'location'),
    (openJobs) => _.map(openJobs, 'name'),
    (openJobs) => _.uniq(openJobs)
  )(openJobs);
  let teams = _.flow(
    (openJobs) => _.map(openJobs, 'departments'),
    (openJobs) => _.map(openJobs, 0),
    (openJobs) => _.map(openJobs, 'name'),
    (openJobs) => _.uniq(openJobs)
  )(openJobs);
  const [location, setLocation] = useState();
  const [team, setTeam] = useState();
  return (
    <Margin size={[7, 0, 5, 0]}>
      <Flex row>
        <Flex flex={2}>
          <Box ratio={1.5} backgroundImage="images/open-roles-picture.jpg" />
        </Flex>

        <Flex flex={4}>
          <Padding size={[0, 10, 0, 6]}>
            <Stack size={3}>
              <Text textType="heading3" align="left">
                Open Roles
              </Text>
              <Text textType="primary2" align="left">
                Our mission is to give voice through beauty, and our team is
                proud to work at Glossier to help democratize an industry that
                has forever been top-down. Explore career & job opportunities at
                Glossier.
              </Text>
              <Margin size={[4, 10, 4, 0]}>
                <Queue size={6}>
                  <DropDown
                    option={location}
                    setOption={setLocation}
                    dropOptions={locations}
                    description="Filter by location"
                  />
                  <DropDown
                    option={team}
                    setOption={setTeam}
                    dropOptions={teams}
                    description="Filter by team"
                  />
                </Queue>
              </Margin>
            </Stack>
          </Padding>
          <Padding size={[5, 6]}>
            <Stack size={5}>
              <Border borderSize={[0, 0, 1, 0]} borderRole="grey3" />

              <Navigation desktop>
                {_.flow(
                  (openJobs) =>
                    _.filter(
                      openJobs,
                      location
                        ? {
                            location: {
                              name: location,
                            },
                          }
                        : {}
                    ),
                  (openJobs) =>
                    _.filter(
                      openJobs,
                      team
                        ? {
                            departments: [{ name: team }],
                          }
                        : {}
                    ),
                  (openJobs) =>
                    _.map(openJobs, (openJob, index) => {
                      return (
                        <PositionDetails
                          loading={loading}
                          openJob={openJob}
                          key={index}
                        />
                      );
                    })
                )(openJobs)}
              </Navigation>
            </Stack>
          </Padding>
        </Flex>
      </Flex>
    </Margin>
  );
};
